import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const ControlOverSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="controlOverSection"
      title={t('client.legal.legalClientBeneficiary.controlOver.title')}
    >
      <FormContent {...formProps} />
    </Section>
  );
};
